import React, { useState, useEffect } from 'react';

export const BigCountdown = ({ endTime }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const end = new Date(endTime).getTime();
      const now = new Date().getTime();
      const difference = end - now;

      if (difference <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((difference % (1000 * 60)) / 1000)
      };
    };

    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  const TimeBox = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <div className="flex gap-0.5 md:gap-1">
        {String(value).padStart(2, '0').split('').map((digit, idx) => (
          <div key={idx} className="bg-gray-100 text-[#0a1628] text-xl sm:text-3xl md:text-4xl font-bold w-7 sm:w-10 md:w-12 h-9 sm:h-12 md:h-14 flex items-center justify-center rounded-md md:rounded-lg">
            {digit}
          </div>
        ))}
      </div>
      <span className="text-[10px] sm:text-xs text-[#64748b] uppercase tracking-wider mt-1 md:mt-2">{label}</span>
    </div>
  );

  return (
    <div className="flex gap-2 sm:gap-4 md:gap-6">
      <TimeBox value={timeLeft.days} label="Giorni" />
      <TimeBox value={timeLeft.hours} label="Ore" />
      <TimeBox value={timeLeft.minutes} label="Minuti" />
      <TimeBox value={timeLeft.seconds} label="Secondi" />
    </div>
  );
};

export const CountdownTimer = ({ endTime, onEnd }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isEnded, setIsEnded] = useState(false);
  const [totalSeconds, setTotalSeconds] = useState(Infinity);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const end = new Date(endTime).getTime();
      const now = new Date().getTime();
      const difference = end - now;

      if (difference <= 0) {
        setIsEnded(true);
        setTotalSeconds(0);
        if (onEnd) onEnd();
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      setTotalSeconds(Math.floor(difference / 1000));

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((difference % (1000 * 60)) / 1000)
      };
    };

    setIsEnded(false);
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime, onEnd]);

  if (isEnded) {
    return <span className="countdown-timer text-red-500 font-bold">TERMINATA</span>;
  }

  const isUrgent = totalSeconds <= 900;

  return (
    <div className={`countdown-timer flex gap-2 font-bold ${isUrgent ? 'countdown-urgent' : ''}`}>
      {timeLeft.days > 0 && <span>{timeLeft.days}g</span>}
      <span>{String(timeLeft.hours).padStart(2, '0')}:</span>
      <span>{String(timeLeft.minutes).padStart(2, '0')}:</span>
      <span>{String(timeLeft.seconds).padStart(2, '0')}</span>
    </div>
  );
};
